// jQuery(document).ready(function ($) {
//     $(".btnShowAllOutlineCards").on("click", function (e) {
//         e.preventDefault();
//         $(".hide-card").removeClass("hide-card");
//         $(this).hide();
//     });
// });

// Scroll-triggered count-up for the stat-card variant.
// imbCountUp() lives in 2024/js/global.js, which this block declares as a dependency.
document.addEventListener("DOMContentLoaded", function () {
  if (typeof imbCountUp !== "function") return;

  document.querySelectorAll("section.outline-card-grid").forEach(function (section) {
    if (section.querySelector(".js-countup")) imbCountUp(section);
  });
});
